import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IMyOskStudentInvitationResultVm } from '../my-osk-student-invitation-result-vm.model';
import { IMyOskStudentInvitationIm } from '../my-osk-student-invitation-im.model';
@Injectable({ providedIn: 'root' })
export class MyOskStudentInvitationService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/MyOskStudentInvitation`;
  }
  post(myOskStudentInvitationIm: IMyOskStudentInvitationIm): Observable<IMyOskStudentInvitationResultVm> {
    const headers = this.createHeaders();
    return this.http.post<IMyOskStudentInvitationResultVm>(this.baseUrl, myOskStudentInvitationIm, { headers });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
